import * as types from './mutation-types'
import CacheHelper from '@/cacheHelper'
import documentsApi from '@/api/documents'

const cacheConfig = {
	key_policies: 'DOCUMENTS_POLICIES',
	key_forms: 'DOCUMENTS_FORMS',
	ttl: 60 * 5, // 5 mins
}

const cache = new CacheHelper(cacheConfig)

/**
 * All VueX actions should go here.
 * They should check if data exists via the cache, and any api calls should be made to the /flat endpoint by default
 */
export const actions = {
	/**
	 * Set the filter limit of results
	 * TODO: Should this be global?
	 */
	async setLimit({ commit }, limit) {
		commit(types.SET_FILTER_LIMIT, limit)
		return Promise.resolve(limit)
	},

	/**
	 * Clear localStorage cache
	 * * TODO: Should this be global?
	 */
	async clearCache(context) {
		cache.removeItem(cacheConfig.key_policies)
		cache.removeItem(cacheConfig.key_forms)
		return Promise.resolve()
	},

	async getDocuments({ dispatch, commit }, options) {
		// need to reset, set the document type, then the tabFilter, then list
		/**
		 * Update to only use bits we need from documents store, as loading two types of content seem to be conflicting
		 */
		let docType
		let documents = []
		if (options.docType === 'forms') {
			docType = {
				singular: 'form',
				plural: 'forms',
			}
		} else {
			docType = {
				singular: 'policy',
				plural: 'policies',
			}
		}

		if (cache.existsAndIsValid(cacheConfig[`key_${docType.plural}`])) {
			documents = cache.getItem(cacheConfig[`key_${docType.plural}`])
			commit(types.SET_DOCUMENTS, {
				docType: options.docType,
				documents: documents,
			})
			return Promise.resolve(documents)
		}

		const limit = options && options.limit ? options.limit : 100

		const filter = {
			sort: [
				{
					[`${docType.singular}_title.raw`]: {
						order: 'asc',
					},
				},
			],
			size: limit,
			query: {
				bool: {
					must: [
						{
							match: {
								[`${docType.singular}_title`]: {
									query: '',
									operator: 'and',
									zero_terms_query: 'all',
									fuzziness: 'AUTO',
								},
							},
						},
						{
							term: {
								status: 'approved',
							},
						},
					],
				},
			},
		}

		try {
			documents = await documentsApi.list(docType, filter, true)
			cache.setItem(cacheConfig[`key_${docType.plural}`], documents.documents, true)
			commit(types.SET_DOCUMENTS, {
				docType: options.docType,
				documents: documents.documents,
			})
			return Promise.resolve(documents.documents)
		} catch (err) {
			console.log(err)
			return Promise.reject(err)
		}
	},
}
